import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, tap, catchError } from 'rxjs/operators';
import { AddrCountryModel } from "src/app/models/address/addrCountry.model";
import { AddrStateModel } from "src/app/models/address/addrState.model";
import { AddressModel } from "src/app/models/address/address.model";


@Injectable({
    providedIn: 'root'
})
export class AddressService {

    private ADDRESS_URL = 'api/address/'
    private ADDRESS_BY_DIST_URL = 'api/address/getAddressByDist/'
    private ADDR_STATE_URL = "api/address/addrStates"
    private ADDR_COUNTRY_URL = "api/address/addrCountries"
    private ADDRESS_SAVE_URL = 'api/address/saveAddress'
    private REMOVE_ADDRESS_URL = 'api/address/removeAddress/'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    getAddress$(id: number): Observable<AddressModel> {
        return this._httpClient.get<AddressModel>(`${this.ADDRESS_URL}${id}`);
      }


    getAddressByDistId$(id: number): Observable<string | null> {
        return this._httpClient.get(`${this.ADDRESS_BY_DIST_URL}${id}`, { responseType: 'text' }).pipe(
            catchError(error => {
                console.error('Error fetching address:', error);
                return of(null);
            })
        );
    }


      get getAddrStates$(): Observable<AddrStateModel[]> {
        return this._httpClient.get<AddrStateModel[]>(this.ADDR_STATE_URL);
    }

    get getAddrCountries$(): Observable<AddrCountryModel[]> {
        return this._httpClient.get<AddrCountryModel[]>(this.ADDR_COUNTRY_URL);
    }

    /* saveAddress$(addressModel: AddressModel, isEdit: boolean): Observable<AddressModel | null> {
        return this._httpClient.post<AddressModel>(this.ADDRESS_SAVE_URL, {AddressModel: addressModel, IsEdit: isEdit}).pipe(
            tap(response => {

            }),
            catchError(error => {
              console.log(error);
              return of(null);
            }),      
          );
    } */


    saveAddress$(addressModel: AddressModel): Observable<string> {
        return this._httpClient.post(this.ADDRESS_SAVE_URL, {AddressModel: addressModel}, {responseType: 'text'});
    }

    saveAddress2$(addressModel: AddressModel): Observable<any> {
        return this._httpClient.post<any>(this.ADDRESS_SAVE_URL, {AddressModel: addressModel});
    }

    removeAddress$(id: number): Observable<number> {
        return this._httpClient.get<number>(`${this.REMOVE_ADDRESS_URL}${id}`);
    }

}
